import { z } from 'zod';
import { metadata } from './helpers';
import { contentBase } from './content';

export const waysToHelpContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    items: z.array(
      z.object({
        title: z.string(),
        description: z.string(),
        url: z.string(),
        image: z.string(),
        position: z.number(),
      })
    ),
  }),
});

export const contentTypeWaysToHelpContentSchema = contentBase.extend({
  content: waysToHelpContentSchema,
});

export type ContentTypeWaysToHelpContentInput = z.infer<typeof contentTypeWaysToHelpContentSchema>;
